import { Injectable } from '@angular/core';
import { Gateway } from '../classes/gateway';
import { APIService } from './api.service';
import { StoreService } from './store.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';
import { WeatherService } from './weather.service';

@Injectable({
  providedIn: 'root'
})
export class GatewayService {
  static readonly API_URL = 'https://gqft0obwmi.execute-api.eu-west-2.amazonaws.com/v1';
  static readonly STATUS_TYPES = ['', 'Configuration', 'Testing', 'Deployed', 'Deleted', 'Stock', 'Discovered', 'New', 'Delivered', 'Faulty', 'Demo', 'Engineer', 'Cancelled'];

  constructor(private apiService: APIService, private http: HttpClient, private storeService: StoreService, private weatherService: WeatherService) { }

  async getSimpleGateway(gatewayId: string): Promise<SimpleGateway> {
    const url = `${GatewayService.API_URL}`;
    const params = new HttpParams()
      .set('a', 'get-simple-item')
      .set('id', gatewayId);
    const options = { ...this.apiService.getUAOHeaders(), params };
    const gateway = await lastValueFrom(this.http.get<any>(url, options));

    gateway.wCSS = this.weatherService.textWeatherToFont(gateway.localWeatherIcon);


    return gateway as SimpleGateway;
  }

  async getGrafanaGateways(): Promise<SimpleGateway[]> {
    const url = `${GatewayService.API_URL}`;
    const params = new HttpParams()
      .set('a', 'get-grafana');
    const options = { ...this.apiService.getUAOHeaders(), params };
    const response = await lastValueFrom(this.http.get<any>(url, options));

    response.forEach(g => {
      if (g.localWeatherTemp) {
        g.wCSS = this.weatherService.textWeatherToFont(g.localWeatherIcon);
      }
    });

    return response as SimpleGateway[];
  }

  getFavouriteGateways(): string[] {
    const org = this.apiService.getUserOrg();
    const key = `org:${org.id}:gateways:fav`;
    const existing: string[] = (localStorage.getItem(key) || "").split(',').filter(i => i);

    return existing;
  }

  saveFavouriteGateways(gatewayList: string[]) {
    const org = this.apiService.getUserOrg();
    const key = `org:${org.id}:gateways:fav`;
    localStorage.setItem(key, gatewayList.join(','));
  }

  toggleFavouritGateway(gateway: Gateway): string[] {
    const existing = this.getFavouriteGateways();
    let newList: string[];
    if (existing.findIndex(i => i === gateway.id) !== -1) {
      newList = existing.filter(i => i !== gateway.id);
    } else {
      newList = [...existing, gateway.id];
    }
    this.saveFavouriteGateways(newList);

    return newList;
  }

}


export interface SimpleGateway {
  id: string;
  title: string;
  grafana_key: string;
  site_id: number;
  siteTitle: string;
  orgId: number;
  orgTitle: string;
  localWeatherTemp: number;
  localWeatherIcon: string;
  wTemp: number;
  wPressure: number;
  wIcon: string;
  wCSS: string;
}
